import { createContext } from 'react';
import { HiProConsentWithTextDto } from 'app/shared/interfaces/HiProApplicationResponse.interface';
import { InstallmentOffer } from './MubiInstallmentsRadioOption.interfaces';
import { InstallmentsEnum } from 'app/shared/enums';

export interface MubiInstallmentsContextInterface {
  hiProToken: string | undefined;
  setHiProToken: (value: string | undefined) => void;
  closeModal: (stepName?: string) => void;
  setHiProConsents: (data: HiProConsentWithTextDto[]) => void;
  hiProConsents: HiProConsentWithTextDto[] | null;
  setInstallmentOffer: (offer: InstallmentOffer) => void;
  installmentOffer: InstallmentOffer | undefined;
  setErrorOnModal: (error: {
    title: InstallmentsEnum;
    message: InstallmentsEnum;
    btnLabel: InstallmentsEnum;
  }) => void;
  setHiProInstalmentContractConfirmed: (value: boolean) => void;
  setIsRejected: (value: boolean) => void;
  mubiInstallmentsDataLayerEvent: (event: string, stepName: string) => void;
  activeStep: number;
  setActiveStep: (step: number) => void;
}

export const MubiInstallmentsContext = createContext<MubiInstallmentsContextInterface>(
  {
    hiProToken: undefined,
    setHiProToken: () => {},
    closeModal: () => {},
    setHiProConsents: () => {},
    hiProConsents: [],
    setInstallmentOffer: () => {},
    installmentOffer: undefined,
    setErrorOnModal: () => {},
    setHiProInstalmentContractConfirmed: () => {},
    setIsRejected: () => {},
    mubiInstallmentsDataLayerEvent: () => {},
    activeStep: 0,
    setActiveStep: () => {},
  }
);
